<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<p class="Head"><span class="bold">Dedication</span></p>
<p class="paraNoIndent1">Arvonia Elizabeth Vaughn, Great Falls, Montana.</p>
<p class="paraNoIndent1">My Dear Little Daughter:</p>
<p class="para">The following series of letters, which include a short history of Montana’s early days, together with a brief sketch of your father’s life and a copy of my letter to you, giving an obituary of your dear mother, I dedicate to you, knowing that they will be appreciated, and hoping that you will have the pleasure of reading them after I am gone.</p>
<p class="para">Your affectionate father,</p>
<p class="Rightpara"><em class="italic">R<span class="smallcaps">OBERRT</span> V<span class="smallcaps">AUGHN</span></em>.</p>
<p class="Rightpara"><em class="italic">G<span class="smallcaps">REAT</span> F<span class="smallcaps">ALLS</span>, M<span class="smallcaps">ONTANA</span>, M<span class="smallcaps">AY</span> 15<span class="smallcaps">TH</span>, 1900</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_ThenandNowbook_dedication.vue?2d390fa2